<template>
  <div class="regulatory-pending" :class="blocked ? 'regulatory-pending-blocked' : ''">
    <div class="regulatory-pending-icon">
      <i class="bi" :class="blocked ? 'bi-slash-circle' : 'bi-exclamation-triangle'"></i>
    </div>
    <div class="regulatory-pending-content">
      <p class="regulatory-pending-title">{{ title }}</p>
      <p class="regulatory-pending-text">
        <strong>“{{ classification.drug_name }}”</strong>
        <span v-if="classification.reason_description"> — {{ classification.reason_description }}</span>
      </p>
      <p v-if="classification.note" class="regulatory-pending-note">{{ classification.note }}</p>

      <template v-if="blocked">
        <p class="regulatory-pending-text">
          Remova este medicamento da lista para conseguir gerar a prescrição.
        </p>
      </template>
      <template v-else>
        <p class="regulatory-pending-text">
          Selecione o receituário correto — a escolha fica registrada em seu nome.
        </p>
        <div class="regulatory-pending-actions">
          <select class="form-control form-select form-select-sm regulatory-pending-select"
                  :id="'regulatory_type_' + classification.id_presc_drug"
                  :disabled="readonly || saving"
                  v-model="selected"
                  aria-label="Selecione o tipo de receituário">
            <option value="" disabled>--Selecione o receituário--</option>
            <option :value="type.code" v-for="type in types" :key="type.code">{{ type.name }}</option>
          </select>
          <button type="button" class="btn btn-sm btn-primary"
                  :disabled="readonly || saving || !selected"
                  @click="$emit('confirm', selected)">
            {{ saving ? 'Salvando...' : 'Confirmar' }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegulatoryManualSelect",
  emits: ['confirm'],
  props: {
    classification: {
      type: Object,
      required: true,
    },
    types: {
      type: Array,
      default: () => [],
    },
    saving: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      selected: '',
    }
  },
  computed: {
    blocked() {
      return this.classification.status === 'BLOCKED';
    },
    title() {
      return this.blocked
          ? 'Este medicamento não pode ser prescrito.'
          : 'Não conseguimos identificar o tipo de receituário deste medicamento.';
    },
  },
}
</script>

<style scoped>
.regulatory-pending {
  display: flex;
  gap: 12px;
  background: #f8fbff;
  border: 1px dashed #1864ab;
  border-radius: 8px;
  padding: 12px 16px;
}

.regulatory-pending-blocked {
  background: #fff5f5;
  border: 1px solid #c92a2a;
}

.regulatory-pending-icon {
  color: #1864ab;
  font-size: 1.25rem;
  line-height: 1;
  padding-top: 2px;
}

.regulatory-pending-blocked .regulatory-pending-icon {
  color: #c92a2a;
}

.regulatory-pending-content {
  flex: 1;
}

.regulatory-pending-title {
  font-weight: 700;
  color: #212529;
  margin: 0 0 4px 0;
}

.regulatory-pending-text {
  color: #495057;
  margin: 0 0 6px 0;
}

.regulatory-pending-note {
  color: #495057;
  font-style: italic;
  margin: 0 0 6px 0;
}

.regulatory-pending-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.regulatory-pending-select {
  max-width: 320px;
}
</style>
